import { CERTIFICATIONS } from "../data/constants";
import { IconCheck, IconClock } from "./icons";

export default function Certifications() {
  return (
    <>
      <section id="certs" className="sec">
        <p className="sec-marker reveal">{"# education & credentials"}</p>

        <div className="grid-cards">
          {CERTIFICATIONS.map((c, i) => {
            const done = c.status === "completed";
            return (
              <article className={`panel reveal d${i + 1}`} key={c.title} style={{ padding: 22 }}>
                <div style={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  gap: 12, marginBottom: 16,
                }}>
                  <span style={{ fontSize: 10.5, color: "var(--fg-mute)" }}>{c.provider}</span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 6, fontSize: 10,
                    color: done ? "var(--ok)" : "var(--accent)",
                  }}>
                    {done ? <IconCheck width={12} height={12} /> : <IconClock width={12} height={12} />}
                    {c.status}
                  </span>
                </div>

                <h3 className="h3">{c.title}</h3>
                <p className="prose" style={{ fontSize: 11.5, marginTop: 10 }}>{c.desc}</p>

                <p className="row-year" style={{
                  marginTop: 18, paddingTop: 14, borderTop: "1px solid var(--line)",
                }}>
                  {c.year}
                </p>
              </article>
            );
          })}
        </div>
      </section>

      <p className="watermark reveal" aria-hidden="true">
        KEEP<br /><span className="filled">GOING</span>
      </p>
    </>
  );
}
